import { render, staticRenderFns } from "./addYield.vue?vue&type=template&id=56ab905e&scoped=true&"
import script from "./addYield.vue?vue&type=script&lang=js&"
export * from "./addYield.vue?vue&type=script&lang=js&"
import style0 from "./addYield.vue?vue&type=style&index=0&id=56ab905e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab905e",
  null
  
)

export default component.exports